import {MutableRefObject} from 'react';

import {useEffectOnce} from './useEffectOnce';

const useMount = (fn: () => void) => {
    useEffectOnce((cancelRef?: MutableRefObject<boolean>) => {
        if (cancelRef?.current) {
            return;
        }

        fn();
    });
};

export default useMount;
